import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/mobile/text-share.png'
import _imports_1 from '@/assets/images/mobile/share-image.svg'


const _hoisted_1 = { class: "container-mobile overflow-auto" }
const _hoisted_2 = { class: "content position-relative" }
const _hoisted_3 = { class: "share-image d-flex flex-column align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "title text-white pt-2"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: "",
  class: "cn-img pt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "mt-4",
  src: _imports_1,
  alt: "share-image"
}, null, -1)
const _hoisted_7 = { class: "share-content mx-auto pb-3" }
const _hoisted_8 = { class: "section section-1 bg-white rounded-3 mb-3 d-flex flex-column align-items-center" }
const _hoisted_9 = { class: "title custom-fs-18 color-nineh position-relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "qr-container mt-3 border border-2 position-relative" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "qrcode position-relative z-1",
    id: "qrcode"
  })
], -1)
const _hoisted_11 = { class: "p-des mt-3" }
const _hoisted_12 = { class: "share-code d-flex align-items-center mt-3" }
const _hoisted_13 = { class: "me-2 my-inv" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.27097 2.16797C5.15507 2.16797 5.04392 2.21401 4.96196 2.29596C4.88001 2.37792 4.83397 2.48907 4.83397 2.60497V3.83497H10.73C11.524 3.83497 12.168 4.47797 12.168 5.27197V11.168H13.397C13.513 11.1677 13.6241 11.1214 13.706 11.0393C13.788 10.9572 13.834 10.846 13.834 10.73V2.60497C13.8337 2.48915 13.7876 2.37815 13.7057 2.29625C13.6238 2.21436 13.5128 2.16823 13.397 2.16797H5.27097ZM12.168 12.168V13.397C12.168 14.191 11.524 14.834 10.73 14.834H2.60497C2.22393 14.8337 1.85858 14.6822 1.58915 14.4128C1.31972 14.1434 1.16823 13.778 1.16797 13.397V5.27097C1.16797 4.47697 1.81097 3.83297 2.60497 3.83297H3.83497V2.60497C3.83497 1.81097 4.47797 1.16797 5.27197 1.16797H13.397C14.191 1.16797 14.834 1.81097 14.834 2.60497V10.73C14.834 11.524 14.191 12.168 13.397 12.168H12.167H12.168ZM2.60497 4.83397C2.5475 4.83397 2.49059 4.8453 2.4375 4.86733C2.38442 4.88935 2.3362 4.92163 2.29561 4.96232C2.25502 5.003 2.22285 5.05129 2.20095 5.10443C2.17904 5.15756 2.16784 5.2145 2.16797 5.27197V13.397C2.16797 13.638 2.36397 13.834 2.60497 13.834H10.73C10.846 13.834 10.9572 13.788 11.0393 13.706C11.1214 13.6241 11.1677 13.513 11.168 13.397V5.27097C11.168 5.1548 11.1218 5.0434 11.0397 4.96126C10.9575 4.87911 10.8461 4.83297 10.73 4.83297H2.60497V4.83397Z",
    fill: "#666666"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "btn-group d-flex mt-3 justify-content-center" }
const _hoisted_17 = { class: "section section-2 position-relative bg-white rounded-3 mb-3 d-flex flex-wrap justify-content-around" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "shared fw-semibold text-black" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "amount fw-semibold text-black" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "section section-3 bg-white rounded-3 d-flex flex-column align-items-center" }
const _hoisted_25 = { class: "title custom-fs-18 color-nineh position-relative mb-3" }
const _hoisted_26 = { class: "share-list text-start" }
const _hoisted_27 = { class: "item item-2 position-relative" }
const _hoisted_28 = { class: "title-item mb-1 text-black" }
const _hoisted_29 = { class: "des-item m-0" }
const _hoisted_30 = { class: "des-item m-0" }
const _hoisted_31 = { class: "table-warpper" }
const _hoisted_32 = { class: "share-table table table-bordered" }
const _hoisted_33 = { class: "warning mt-3 p-3 px-4 rounded-3" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<svg class=\"mb-1\" width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4475_9477)\"><path d=\"M11.5129 1.86906C9.84937 1.79683 8.25678 1.23426 6.77897 0.19645L6.49887 0L6.2195 0.19645C4.74259 1.23409 3.14984 1.79683 1.49678 1.8687H0.974609V6.2677C0.974609 9.49001 3.19746 12.2493 6.38048 12.9777L6.51936 13L6.61912 12.9777C9.8014 12.2493 12.0239 9.49001 12.0239 6.2677V1.8687L11.5129 1.86907L11.5129 1.86906ZM9.53033 4.84332L5.97996 8.52695C5.89087 8.60914 5.75074 8.60372 5.66835 8.51464L3.46324 6.17355C3.38105 6.08446 3.38647 5.94433 3.47555 5.86194L3.53186 5.80997C3.62094 5.72778 3.76107 5.7332 3.84346 5.82228L5.83329 7.93486L9.16114 4.48045C9.24624 4.39391 9.38656 4.39282 9.47293 4.47792L9.52743 4.53169C9.61416 4.6166 9.61524 4.75695 9.53033 4.84332Z\" fill=\"#FD2E2E\"></path></g><defs><clipPath id=\"clip0_4475_9477\"><rect width=\"13\" height=\"13\" fill=\"white\"></rect></clipPath></defs></svg>", 1)
const _hoisted_35 = { class: "ms-2 text-start" }
const _hoisted_36 = { class: "section mt-3 p-0 final-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tips = _resolveComponent("tips")!
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_dialog_share_tips = _resolveComponent("dialog-share-tips")!
  const _component_dialog_referral_rewards = _resolveComponent("dialog-referral-rewards")!
  const _component_screen_shot = _resolveComponent("screen-shot")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.$route.query.lang?.toString().toLowerCase() == 'en')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.local.share_2) + _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + "%", 1))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.local.share_3), 1),
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, _toDisplayString($setup.local.share_4), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString($setup.local.share_5), 1),
              _createElementVNode("div", {
                ref: "textToCopy",
                class: "me-2 code text-black fw-semibold"
              }, _toDisplayString($setup.shareInfo.inviteCode), 513),
              _createElementVNode("div", {
                class: "copy-code",
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyCode()))
              }, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "share-btn btn-linkk",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.copyLink()))
              }, _toDisplayString($setup.local.share_6), 1),
              _createElementVNode("button", {
                class: "share-btn btn-image",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.captureScreenshot().finally(()=>$setup.takeScreenisDone())))
              }, _toDisplayString($setup.local.share_7), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString($setup.shareInfo.invitesShareCount), 1),
              _createElementVNode("p", _hoisted_20, _toDisplayString($setup.local.share_8), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString($setup.shareInfo.userAvailablePurchasePointsNoRefundNoPendingYuan), 1),
              _createElementVNode("p", _hoisted_23, _toDisplayString($setup.local.share_9), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString($setup.local.share_10), 1),
            _createElementVNode("ul", _hoisted_26, [
              _createElementVNode("li", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString($setup.local.share_13) + _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + "%", 1),
                _createElementVNode("p", _hoisted_29, _toDisplayString($setup.local.share_14), 1),
                _createElementVNode("p", _hoisted_30, _toDisplayString($setup.local.share_15), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("table", _hoisted_32, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString($setup.local.share_16), 1),
                    _createElementVNode("th", null, _toDisplayString($setup.local.share_17), 1),
                    _createElementVNode("th", null, _toDisplayString($setup.local.share_18), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString($setup.local.share_19), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + "% ", 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[0].renew_percent) + "% ", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString($setup.local.share_20), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[1].new_purchase_percent) + "%", 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[1].renew_percent) + "% ", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString($setup.local.share_21), 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[2].new_purchase_percent) + "% ", 1),
                    _createElementVNode("td", null, _toDisplayString($setup.shareInfo.share_rebate[2].renew_percent) + "%", 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "info-share-btn mt-2 align-self-start color-nineh",
              role: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleComponent('isReferralRewards')))
            }, _toDisplayString($setup.local.share_22), 1),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, _toDisplayString($setup.local.share_23), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, _toDisplayString($setup.local.share_24), 1)
        ])
      ]),
      _createVNode(_component_tips, { ref: "tipsRef" }, null, 512),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
            [_vShow, $setup.state.isCopiedLink || $setup.state.isReferralRewards || $setup.state.showLoading]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_share_tips, {
            onHide: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleComponent('isCopiedLink')))
          }, null, 512), [
            [_vShow, $setup.state.isCopiedLink]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_referral_rewards, {
            onHide: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleComponent('isReferralRewards')))
          }, null, 512), [
            [_vShow, $setup.state.isReferralRewards]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_screen_shot, { ref: "screenShotRef" }, null, 512),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ])
  ], 64))
}